<div class="box-grid">
  <button *ngFor="let b of baskets; trackBy: trackByBasket"
          type="button"
          class="box-tile"
          [class.box-tile--current]="b.basketNumber === currentBasket && !isComplete(b)"
          [class.box-tile--complete]="isComplete(b)"
          [class.box-tile--pulse]="b.basketNumber === pulseBasket"
          (click)="basketClick.emit(b)">
    <div class="box-tile__num">#{{ b.basketNumber }}</div>
    <div class="box-tile__name">{{ b.patientName }}</div>
    <div class="box-tile__dob" *ngIf="b.patientDob">{{ b.patientDob | dob }}</div>
    <div class="box-tile__count">{{ pickedCount(b) }} / {{ b.medications.length }} items</div>
    <div class="box-tile__bar"><span [style.width.%]="progressPercent(b)"></span></div>
    <div class="box-tile__check" *ngIf="isComplete(b)">✓</div>
  </button>
</div>
